import { getFeatureValue } from './growthbook';

export async function resolveShowChatbot(growthbookConfig) {
  const fallback = !!(growthbookConfig && growthbookConfig.fallback);

  if (!growthbookConfig || !growthbookConfig.featureKey) {
    return fallback;
  }

  return getFeatureValue({
    ...growthbookConfig,
    fallback,
  });
}
